<template>
  <message>
    <template slot="icon">
      <i class="far fa-calendar-times text-error" style="font-size: 100px" />
    </template>
    <template slot="text">
      <h3 class="text-error p-t-20">{{ $t('revision-confirm.delete.title').toUpperCase() }}</h3>
      <p>
        {{ $t('revision-confirm.delete.content') }} <br />
        {{ $t('revision-confirm.delete.content-2') }}
      </p>
    </template>
    <template slot="bottom">
      <button class="btn col-auto btn-success" @click="$emit('confirm')">
        <i class="fas fa-angle-right"></i>
        {{ $t('revision-confirm.delete.accept') }}
      </button>
    </template>
  </message>
</template>
<script>
import Message from '@/components/dialog/Message'

export default {
  name: 'RevisionDelete',
  components: {
    Message,
  },
}
</script>
